import type { StoreInfo } from '@/types';

export const STORE_DETAILS: StoreInfo = {
  name: 'Bagbazar Provision Stores',
  location: 'Pokhara-1, Bagbazar, Kaski, Nepal',
  phone: '+977-9819102869',
  pan: '611310466',
  owner: 'Radhika Adhikari',
  established: '2076 BS',
};

/** Geo coordinates for Pokhara-1, Bagbazar (LocalBusiness schema). */
export const GEO_COORDINATES = {
  latitude: 28.2096,
  longitude: 83.9856,
} as const;

export const ASSETS = {
  logoBlue: '/images/logo-blue.png',
  storeInterior1: '/images/store-interior-1.jpg',
  storeInterior2: '/images/store-interior-2.jpg',
  storeInterior3: '/images/store-interior-3.jpg',
  ownerPhoto: '/images/owner-photo.jpg',
} as const;

/** Image dimensions for layout stability (reduces CLS). Format: [width, height]. */
export const ASSET_DIMENSIONS: Record<string, [number, number]> = {
  [ASSETS.storeInterior1]: [861, 1530],
  [ASSETS.storeInterior2]: [861, 1530],
  [ASSETS.storeInterior3]: [861, 1530],
  [ASSETS.logoBlue]: [1024, 1024],
  [ASSETS.ownerPhoto]: [1536, 2048],
};

export const FALLBACK_IMAGES = {
  store: 'https://images.unsplash.com/photo-1534723452862-4c874018d66d?w=1000&q=80',
  aisle: 'https://images.unsplash.com/photo-1583258292688-d0213dc5a3a8?w=800&q=80',
  person: 'https://images.unsplash.com/photo-1516594798947-e65505dbb29d?w=800&q=80',
} as const;
